import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import SectionTitle from "./SectionTitle";
import { api } from "../data/api";

export const Shop = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <section id="boutique" className="section bg-gradient-to-b from-[#050505] via-[#07060f] to-[#050505] py-28">
      <div className="orb orb-purple" style={{ width: 400, height: 400, top: "5%", left: "-8%" }} />
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionTitle kicker="Boutique" title="Merch officiel" testid="shop-title" />

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
          {products.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`product-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 5) * 0.08 }}
              className="group glass overflow-hidden rounded-2xl"
            >
              <div className="relative aspect-square overflow-hidden bg-white/5">
                <img src={p.image} alt={p.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <span className="absolute left-3 top-3 rounded-full glass-strong px-3 py-1 font-heading text-[10px] uppercase tracking-wider text-white/70">
                  {p.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-white">{p.name}</h3>
                <p className="mt-1 line-clamp-2 font-body text-xs text-white/50">{p.description}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="gold-text font-display text-lg font-bold">{p.price}€</span>
                  <button
                    data-testid={`add-cart-${i}`}
                    onClick={() => toast.success(`${p.name} ajouté au panier`, { description: "Boutique de démonstration" })}
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-electric transition-transform duration-300 hover:scale-110"
                  >
                    <ShoppingBag size={16} className="text-white" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-center font-body text-xs text-white/40">
          Boutique de démonstration — le paiement sécurisé sera activé prochainement.
        </p>
      </div>
    </section>
  );
};

export default Shop;
